import * as React from "react";
const SvgPhoneAndroid = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M19 1H5v22h14V1zm-5 20h-4v-1h4v1zm3-3H7V4h10v14z",
  fill: "currentColor"
}));
export default SvgPhoneAndroid;